import { GradProgramAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainGradProgramSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainGradProgramSearchRouteData = {
  lang: UserLocale;
  q: string;
  radius?: number | 'auto' | null;
  saved?: boolean;
  filters?: GradProgramAlgoliaApiQueryFilters;
};

export function getMainGradProgramSearchRoutePath(
  data: MainGradProgramSearchRouteData,
) {
  const { lang, filters, q, radius, saved } = data;

  // Extract the segment based on type
  const segment = HOME_PAGE_SLUGS.GRAD_PROGRAM[lang];

  let queryParams = {
    q,
    radius,
    saved: saved || undefined,
  };

  if (filters) {
    // Merge basic and filter-derived query parameters
    queryParams = {
      ...queryParams,
      ...transformSearchFiltersToQueryParams(filters),
    };
  }

  return mainGradProgramSearchRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
